import { render, staticRenderFns } from "./copy-resource-definition-dialog.vue?vue&type=template&id=47c4178c&scoped=true"
import script from "./copy-resource-definition-dialog.vue?vue&type=script&lang=js"
export * from "./copy-resource-definition-dialog.vue?vue&type=script&lang=js"
import style0 from "./copy-resource-definition-dialog.vue?vue&type=style&index=0&id=47c4178c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4178c",
  null
  
)

export default component.exports